export const CASH_TYPES = /** @type {const} */ ({
    리워드: { value: "리워드", text: "리워드" },
    선물: { value: "선물", text: "선물" },
    충전: { value: "충전", text: "충전" },
    주문: { value: "주문", text: "주문" },
    부분취소: { value: "부분취소", text: "부분취소" },
    취소: { value: "취소", text: "취소" },
    마진: { value: "마진", text: "마진" },
});

/** @typedef {keyof typeof CASH_TYPES} Cash_Type */
/** @type {Cash_Type[]} */
export const Enum_Cash_Types = Object.keys(CASH_TYPES);
